import { useNavigate } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center pt-20">
        <div className="text-center px-4">
          <div className="w-20 h-20 flex items-center justify-center rounded-full bg-accent-100 mx-auto mb-6">
            <i className="ri-error-warning-line text-3xl text-accent-500" />
          </div>
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 mb-4">
            404
          </h1>
          <p className="text-lg text-foreground-600 mb-2">
            Strona nie została znaleziona
          </p>
          <p className="text-sm text-foreground-500 mb-8 max-w-md mx-auto">
            Przepraszamy, ale strona której szukasz nie istnieje lub została przeniesiona.
          </p>
          <button
            onClick={() => navigate("/")}
            className="px-7 py-3.5 bg-primary-500 text-white font-semibold rounded-full hover:bg-primary-600 transition-colors shadow-md whitespace-nowrap cursor-pointer"
          >
            Wróć na stronę główną
          </button>
        </div>
      </main>
      <Footer />
    </div>
  );
}